import { httpservice } from '../services';
import { constants } from '../constant/constant';

const doVerifyPhoneNumber = (otp) => httpservice()
  .post(constants.API.VERIFY_PHONE, otp)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default doVerifyPhoneNumber;
